import React, { useMemo, useState } from 'react';
import '../../css/Dashboard.css';
import QueriesComponent from './QueriesComponent';
import FollowUpsComponent from './FollowUpsComponent';
import QueriesOverTimeComponent from './QueriesOverTimeComponent';
import FiltersBar from '../dashboard/FiltersBar';
import StatsRow from '../dashboard/StatsRow';
import PaymentsRow from '../dashboard/PaymentsRow';
import DepartingPackages from '../dashboard/DepartingPackages';
import ByTypeChart from '../dashboard/ByTypeChart';
import ByAssigneeChart from '../dashboard/ByAssigneeChart';
import BookingStackedChart from '../dashboard/BookingStackedChart';
import { DashboardDataProvider, useDashboardData } from './DashboardDataContext';
import * as FiIcons from 'react-icons/fi';
const FiRefreshCw = FiIcons.FiRefreshCw as unknown as React.FC;

const SalesDashboard = () => {
  // Filter state (would feed API queries)
  const [queryType, setQueryType] = useState<string>('');
  const [month, setMonth] = useState<'' | 'prev' | 'last3' | 'ytd'>('');
  const [assignee, setAssignee] = useState<string>('');

  const filters = useMemo(() => ({ queryType, month, assignee }), [queryType, month, assignee]);

  const RefreshBtn: React.FC = () => {
    const { refresh, loading } = useDashboardData();
    return (
      <button className="btn" onClick={refresh} disabled={loading} title="Refresh dashboard">
        <FiRefreshCw /> {loading ? 'Refreshing…' : 'Refresh'}
      </button>
    );
  };

  const FilterBarWithOptions: React.FC = () => {
    const { data } = useDashboardData();
    const typeOptions = useMemo(() => {
      const arr = (data?.queriesByType || []).map(x => x.type).filter(Boolean);
      const uniq = Array.from(new Set(arr));
      return uniq.map(t => ({ value: String(t), label: String(t).charAt(0).toUpperCase() + String(t).slice(1) }));
    }, [data]);
    const assigneeOptions = useMemo(() => {
      return (data?.queriesByAssignee || []).map(x => ({ value: String(x.assigneeId), label: x.assigneeName }));
    }, [data]);
    return (
      <FiltersBar
        queryType={queryType}
        month={month}
        assignee={assignee}
        onChange={(next) => {
          if (next.queryType !== undefined) setQueryType(next.queryType);
          if (next.month !== undefined) setMonth(next.month);
          if (next.assignee !== undefined) setAssignee(next.assignee);
        }}
        typeOptions={typeOptions}
        assigneeOptions={assigneeOptions}
      />
    );
  };

  return (
    <div className="db-container">
      <DashboardDataProvider filters={filters}>
      <div className="db-header">
        <h2>GoCompassia Dashboard</h2>
        <FilterBarWithOptions />
        <RefreshBtn />
      </div>

      <div className="db-row">
        <StatsRow filters={filters} />
      </div>

      <div className="db-row db-grid-3">
        <div className="card"><QueriesComponent /></div>
        <div className="card"><FollowUpsComponent /></div>
        <div className="card"><DepartingPackages /></div>
      </div>

      <div className="db-row">
        <PaymentsRow />
      </div>

      <div className="db-row db-grid-2">
        <div className="card"><ByTypeChart /></div>
        <div className="card"><ByAssigneeChart /></div>
      </div>

      <div className="db-row db-grid-2">
        <div className="card"><QueriesOverTimeComponent /></div>
        <div className="card"><BookingStackedChart /></div>
      </div>
      </DashboardDataProvider>
    </div>
  );
};

export default SalesDashboard;
